import { render, staticRenderFns } from "./FormItemList.vue?vue&type=template&id=6a141e5d"
import script from "./FormItemList.vue?vue&type=script&lang=js"
export * from "./FormItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports